'use strict';
define(['app'], function (app) {
    app.component('stIconPicker', {
        templateUrl: 'app/components/st-icon-picker/st-icon-picker.html',
        controller: Controller,
        bindings: {
            items: '<',
            value: '=',
            iconOnly: '<',
            placeholder: '@',
            ariaLabel: '@',
            emptyText: '@',
            onChange: '&'
        }
    });

    function Controller($element, $timeout) {
        var ctrl = this;
        ctrl.search = '';
        ctrl.open = false;
        ctrl.toggle = toggle;
        ctrl.close = close;
        ctrl.filteredItems = filteredItems;
        ctrl.selectItem = selectItem;
        ctrl.selectedItem = selectedItem;
        ctrl.isEmpty = isEmpty;
        ctrl.isSelected = isSelected;

        function toggle() {
            ctrl.open = !ctrl.open;
            ctrl.search = '';
            if (ctrl.open) {
                $timeout(function () {
                    var input = $element[0].querySelector('.st-icon-picker__search input');
                    if (input) input.focus();
                }, 0);
            }
        }

        function close() {
            ctrl.open = false;
            ctrl.search = '';
        }

        function selectedItem() {
            var items = Array.isArray(ctrl.items) ? ctrl.items : [];
            for (var i = 0; i < items.length; i++) {
                if (String(items[i].value) === String(ctrl.value)) return items[i];
            }
            return null;
        }

        function filteredItems() {
            var items = Array.isArray(ctrl.items) ? ctrl.items : [];
            var term = String(ctrl.search || '').trim().toLowerCase();
            if (!term) return items;
            return items.filter(function (item) {
                return String(item.label || '').toLowerCase().indexOf(term) >= 0
                    || String(item.value || '').toLowerCase().indexOf(term) >= 0;
            });
        }

        function isEmpty() {
            return filteredItems().length === 0;
        }

        function isSelected(item) {
            return !!item && String(item.value) === String(ctrl.value);
        }

        function selectItem(item) {
            if (!item || item.disabled) return;
            ctrl.value = item.value;
            ctrl.search = '';
            ctrl.open = false;
            if (ctrl.onChange) ctrl.onChange({item: item});
        }
    }

    Controller.$inject = ['$element', '$timeout'];

    return Controller;
});
